import { Injectable } from '@angular/core';
import { TimeZoneEntryDto } from '@osos/shared/api';
import { TimeZonePresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases';
@Injectable({
  providedIn: 'root',
})
export class TimeZoneParserV1Service extends ParserBase<
  TimeZoneEntryDto,
  TimeZonePresenterModel
> {
  constructor() {
    super(TimeZoneEntryDto, TimeZonePresenterModel, 1);
  }
  override getPresenterModel(
    model: Partial<TimeZoneEntryDto>,
  ): TimeZonePresenterModel {
    return {
      daylight_saving_time_dst: model.daylight_saving_time_dst,
      id: model.id,
      time_difference: model.time_difference,
      time_zone: model.time_zone,
      time_zone_id: model.time_zone_id,
    } as TimeZonePresenterModel;
  }
  override getDataModel(presenter: TimeZonePresenterModel): TimeZoneEntryDto {
    return {
      daylight_saving_time_dst: presenter.daylight_saving_time_dst,
      id: presenter.id,
      time_difference: presenter.time_difference,
      time_zone: presenter.time_zone,
      time_zone_id: presenter.time_zone_id,
    } as TimeZoneEntryDto;
  }
}
